import { render, staticRenderFns } from "./SharedShortlistsFinalCompanies.vue?vue&type=template&id=013cc8b8&"
import script from "./SharedShortlistsFinalCompanies.vue?vue&type=script&lang=js&"
export * from "./SharedShortlistsFinalCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports